exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attempt-list[data-v-a61c881c] {\n  list-style: none;\n}", ""]);

// exports
